import Vue from "vue";
import VueRouter from "vue-router";

// 编程式导航重复路由控制台报错问题修复
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, ...remaining) {
  if (remaining.length) {
    originalPush.apply(this, [location, ...remaining]);
  } else {
    return originalPush.call(this, location).catch((err) => err);
  }
};

const gh = () =>
  import(/* webpackChunkName: "dragonHome" */ "../views/DragonHome.vue");
const pd = () =>
  import(
    /* webpackChunkName: "petDisplay" */ "../views/mainContent/PetDisplay.vue"
  );
const pb = () =>
  import(/* webpackChunkName: "petBattle" */ "../views/PetBattle.vue");
const firstpet = () =>
  import(/* webpackChunkName: "firstPet" */ "../views/FirstPet.vue");
// v2.0
const village = () =>
  import(/* webpackChunkname: "village" */ "../views/villages/Index.vue");
const villageMap_1 = () =>
  import(/* webpackChunkname: "village" */ "../views/villages/Map_1.vue");
// v2.0 end

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "dragonHome",
    component: gh,
    meta: {
      keepAlive: true,
    },
    children: [
      {
        path: "/",
        name: "pd",
        component: pd,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/battle",
    name: "petBattle",
    component: pb,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/firstpet",
    name: "firstPet",
    component: firstpet,
  },
  // v2.0
  {
    path: "/village",
    name: "village",
    component: village,
    children: [
      {
        path: "map_1",
        name: "villageMap1",
        component: villageMap_1,
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "",
        redirect: "map_1",
      },
    ],
    meta: {
      keepAlive: true,
    },
  },
  // v2.0 end
  {
    path: "*",
    redirect: "/",
  },
];
let langs = Object.values(langHash)
    .map((i) => i.code)
    .join("|"),
  regexp = new RegExp(`\/(${langs})\/?`),
  base = "/";
if (regexp.test(location.pathname)) {
  base = location.pathname.match(regexp)[0] + base;
}

const router = new VueRouter({
  // mode: "history",
  base: base,
  routes,
});

export default router;
